module.exports = __webpack_public_path__ + "assets/img/aorganization.e8c5ea97.png";